<template>
	<div>
		<order-list ref='orderList' init hide-edit-field />
	</div>
</template>
<script>
	import orderList from '@/components/sc/windowOrder/list'	

	export default {
		components:{
			orderList
		},
		data(){
			return {
				
			}
		},
		mounted(){
			
		},
		methods:{
			
		}
	}
</script>